/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, type ErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/public/{token}/xlsx
 */
export interface XlsxRequestBuilder extends BaseRequestBuilder<XlsxRequestBuilder> {
    /**
     * Returns the order as an .xlsx workbook whose line totals, subtotal and total are live formulas over numeric quantity and price cells, so editing a quantity recalculates the document. The {token} is the same opaque, time-limited value the public order view accepts. Any invalid, tampered, or expired token — or a token whose order no longer matches its customer — returns 404, so the endpoint reveals nothing about which check failed.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {ErrorResponse} error when the service returns a 429 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * Returns the order as an .xlsx workbook whose line totals, subtotal and total are live formulas over numeric quantity and price cells, so editing a quantity recalculates the document. The {token} is the same opaque, time-limited value the public order view accepts. Any invalid, tampered, or expired token — or a token whose order no longer matches its customer — returns 404, so the endpoint reveals nothing about which check failed.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const XlsxRequestBuilderUriTemplate = "{+baseurl}/api/orders/public/{token}/xlsx";
/**
 * Metadata for all the requests in the request builder.
 */
export const XlsxRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: XlsxRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
};
/* tslint:enable */
/* eslint-enable */
